import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/90 backdrop-blur-xl border-b border-gray-800/50' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-lg flex items-center justify-center shadow-lg shadow-amber-500/20">
            <span className="text-black font-bold text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>RT</span>
          </div>
          <span className="text-xl font-semibold tracking-wide" style={{ fontFamily: 'Montserrat, sans-serif' }}>Rinard Tailors</span>
        </div>

        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('looks')} className="text-gray-300 hover:text-amber-400 transition-colors whitespace-nowrap cursor-pointer">
            Looks
          </button>
          <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-amber-400 transition-colors whitespace-nowrap cursor-pointer">
            Services
          </button>
          <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-amber-400 transition-colors whitespace-nowrap cursor-pointer">
            About
          </button>
          <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-amber-400 transition-colors whitespace-nowrap cursor-pointer">
            Contact
          </button>
          <a
            href="tel:+94771107594"
            className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold rounded-full transition-all shadow-lg shadow-amber-500/30 hover:shadow-amber-500/50 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Call 077 110 7594
          </a>
        </nav>

        {/* Mobile menu button */}
        <button className="md:hidden text-2xl text-amber-400 w-10 h-10 flex items-center justify-center cursor-pointer">
          <i className="ri-menu-line"></i>
        </button>
      </div>
    </header>
  );
}
